import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatDividerModule, MatIconModule, MatInputModule, MatPaginatorModule, MatRadioModule, MatSelectModule, MatSnackBarModule, MatTableModule, MatTooltipModule } from "@angular/material";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDialogModule } from "@angular/material/dialog";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSortModule } from "@angular/material/sort";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ColorPickerModule } from "ngx-color-picker";
import { NgxDropzoneModule } from "ngx-dropzone";
import { DirectiveModule } from "../../model/module/directive.module";
import { PipeModule } from "../../model/module/pipe.module";
import { AlertComponent } from "./alert/alert.component";
import { HolidayEditDialogComponent } from "./holiday-edit-dialog/holiday-edit-dialog.component";
import { MigrationDialogComponent } from "./migration-dialog/migration-dialog.component";
import { StructureVectorComponent } from "./structure-vector/structure-vector.component";
import { StructureVectorTestComponent } from "./structure-vector2/structure-vector2.component";

	/**
	 * @description
	 *	Módulo principal de componentes reutilizables.
	 */

@NgModule({
	declarations: [
		AlertComponent,
		HolidayEditDialogComponent,
		MigrationDialogComponent,
		StructureVectorComponent,
		StructureVectorTestComponent
	],
	entryComponents: [
		AlertComponent,
		HolidayEditDialogComponent,
		MigrationDialogComponent,
		StructureVectorComponent,
		StructureVectorTestComponent
	],
	exports: [
		AlertComponent,
		HolidayEditDialogComponent,
		MigrationDialogComponent,
		StructureVectorComponent,
		StructureVectorTestComponent
	],
	imports: [
		ColorPickerModule,
		CommonModule,
		DirectiveModule,
		DragDropModule,
		FormsModule,
		MatAutocompleteModule,
		MatButtonModule,
		MatCheckboxModule,
		MatDatepickerModule,
		MatDialogModule,
		MatDividerModule,
		MatIconModule,
		MatInputModule,
		MatPaginatorModule,
		MatProgressSpinnerModule,
		MatRadioModule,
		MatSelectModule,
		MatSnackBarModule,
		MatSortModule,
		MatTableModule,
		MatTooltipModule,
		NgbModule,
		NgxDropzoneModule,
		PipeModule,
		ReactiveFormsModule
	]
})
export class ComponentModule {}
